export default __webpack_public_path__ + "static/media/Jerkin of Flowing Water.0d7ec16c.jpg";